// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  OrientationVersion,
  ScriptSource,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  stepId: __t.string().name("step_id"),
  get orientationVersion() {
    return OrientationVersion.name("orientation_version");
  },
  totalDurationEstimateMs: __t.option(__t.u32()).name("total_duration_estimate_ms"),
  get source() {
    return ScriptSource;
  },
  updatedAt: __t.timestamp().name("updated_at"),
  updatedBy: __t.string().name("updated_by"),
});
